import { StaticTranslationResponseMulti, StaticTranslationResponseSingle } from './responses';

export interface LanguageInterface {
  id: number;
  code: string;
  name: string;
  enabled: boolean;
  created_at: Date;
  updated_at: Date;
}

export interface StaticTranslationInterface {
  id: number;
  language_id: number;
  key: string;
  translation: string;
  created_at: Date;
  updated_at: Date;
}

export interface UnsavedStaticTranslation {
  language_id: number;
  key: string;
  translation: string;
}

export class StaticTranslation implements StaticTranslationInterface {
  public static fromResponseSingle(response: StaticTranslationResponseSingle): StaticTranslation {
    return new StaticTranslation(
      response.data.translation.id         ,
      response.data.translation.language_id,
      response.data.translation.key        ,
      response.data.translation.translation,
      response.data.translation.created_at ,
      response.data.translation.updated_at ,
    );
  }

  public static fromResponseMulti(response: StaticTranslationResponseMulti): StaticTranslation[] {
    return response.data.translations.map((translation) => {
      return new StaticTranslation(
        translation.id         ,
        translation.language_id,
        translation.key        ,
        translation.translation,
        translation.created_at ,
        translation.updated_at ,
      );
    });
  }

  constructor(
    public id: number,
    public language_id: number,  // tslint:disable-line variable-name
    public key: string,
    public translation: string,
    public created_at: Date,     // tslint:disable-line variable-name
    public updated_at: Date,     // tslint:disable-line variable-name
  ) { }
}
